import { render, staticRenderFns } from "./ModalProductValues.vue?vue&type=template&id=01a527ca&"
import script from "./ModalProductValues.vue?vue&type=script&lang=js&"
export * from "./ModalProductValues.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductValues.vue?vue&type=style&index=0&id=01a527ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports